import getMaxElementsCount from "./get-max-elements-count";
import sumElementsOnTabs from "./sum-elements-on-tabs";

export default function () {
    const maxSumOfElements = getMaxElementsCount();
    const tabsElementsSum = sumElementsOnTabs();

    return tabsElementsSum <= maxSumOfElements;
}
